export const pad = (val: number, length: number, padding: string): string => {
  let o = `${val}`
  while (o.length < length) {
    o = padding + o
  }
  return o
}
